import { render } from "./LicenseInfoOnPrem.vue?vue&type=template&id=3c092dba"
import script from "./LicenseInfoOnPrem.vue?vue&type=script&lang=js"
export * from "./LicenseInfoOnPrem.vue?vue&type=script&lang=js"

import "./LicenseInfoOnPrem.vue?vue&type=style&index=0&id=3c092dba&lang=css"

import exportComponent from "/root/esg_nexus/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__